import React from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import _ from 'lodash'

import styles from './ItemContextMenu.module.css'

const ItemContextMenu = ({
  itemContextMenuAnchorEl,
  handleItemContextMenuClose,
  handleItemContextMenuItemClick
}) => (
  <Menu
    classes={{ paper: styles.contextMenuLink }}
    open={!_.isNil(itemContextMenuAnchorEl)}
    anchorEl={itemContextMenuAnchorEl}
    onClose={handleItemContextMenuClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
    <MenuItem onClick={() => handleItemContextMenuItemClick('_blank')}>
      <img
        src='/images/icones-menu-abas/abrir-em-nova-aba.svg'
        className={styles.iconeLinksEmAbas}
        alt='Abrir conteúdo em nova aba'
      />
      Abrir em nova aba
    </MenuItem>
    <MenuItem onClick={() => handleItemContextMenuItemClick('_self')}>
      <img
        src='/images/icones-menu-abas/abrir-na-mesma-aba.svg'
        className={styles.iconeLinksEmAbas}
        alt='Abrir conteúdo na mesma aba'
      />
      Abrir na mesma aba
    </MenuItem>
  </Menu>
)

export default ItemContextMenu
